<template>
  <div class="support-container">
    <section class="support-header">
      <h1>格里弗（成都）光电科技有限公司</h1>
      <p class="welcome-text">尊敬的用户：您好！为了给您提供更加优质的产品及服务，请您根据服务需求，填写服务申请，我们将及时与您联系，谢谢！</p>
      <p class="address-info">地址：四川省成都市锦江区绿地中心.468锦锋，门牌号3907号</p>
      <p class="business-hours">营业时间：周一至周五9：00-17：30 周六至周日法定节假日休息</p>
      <p class="phone-info">联系电话：028-84790343</p>
      <p class="form-title">请填写表单信息</p>
    </section>
    <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="100px"
        class="support-form"
        @submit.prevent="submitForm"
    >
      <!-- 第一行：联系人 + 联系电话 -->
      <div class="form-row">
        <el-form-item label="联系人" prop="name" class="form-item">
          <el-input
              v-model="form.name"
              placeholder="请输入姓名"
              clearable
          />
        </el-form-item>
        <el-form-item label="联系电话" prop="phone" class="form-item">
          <el-input
              v-model="form.phone"
              placeholder="请输入联系电话"
              clearable
          />
        </el-form-item>
      </div>

      <!-- 第二行：单位名称 + 服务类型 -->
      <div class="form-row">
        <el-form-item label="单位名称" prop="unitName" class="form-item">
          <el-input
              v-model="form.unitName"
              placeholder="请输入单位名称"
              clearable
          />
        </el-form-item>
        <el-form-item label="服务类型" prop="businessId" class="form-item">
          <el-select
              v-model="form.businessId"
              placeholder="请选择服务类型"
              clearable
          >
            <el-option
                v-for="option in solutions"
                :key="option.id"
                :label="option.name"
                :value="option.id"
            />
          </el-select>
        </el-form-item>
      </div>

      <!-- 第四行：问题描述（单独一行） -->
      <el-form-item label="问题描述" prop="text" class="full-width">
        <el-input
            type="textarea"
            v-model="form.text"
            :rows="4"
            placeholder="请输入描述"
            resize="none"
        />
      </el-form-item>

      <!-- 第五行：添加问题图片（单独一行） -->
      <el-form-item label="添加问题图片" prop="imgs" class="full-width">
        <el-upload
            action="#"
            multiple
            list-type="picture-card"
            :auto-upload="false"
            :on-change="handleImageChange"
            :on-remove="handleImageRemove"
            :file-list="fileList"
            accept="image/jpeg,image/png"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">上传图片(JPG、PNG)（可选）</div>
        </el-upload>
      </el-form-item>

      <!-- 第六行：验证码（单独一行） -->

      <el-form-item class="form-actions">
        <el-button @click="resetForm">清空</el-button>
        <el-button @click="save" type="primary" native-type="submit">提交</el-button>
      </el-form-item>
    </el-form>

    <!-- 成功提交弹窗 -->
    <el-dialog
        v-model="dialogVisible"
        title="提交成功"
        width="30%"
        center
    >
      <span>提交成功，请保持填写电话通畅，我们将会与您回电！</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="out()">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import serviceApi from "@/api/server";

export default {
  setup() {
    const formRef = ref(null)
    const fileList = ref([])
    const dialogVisible = ref(false)
    const captchaText = ref('')
    const solutions = ref([])
    const imgUrl = ref([])
    let number= ref(0)

    let form = reactive({
      id: 0,
      name: '',
      phone: '',
      unitName: '',
      businessId: '',
      text: '',
      imgs: '',
      time: ''
    })

    // 生成随机验证码
    const generateCaptcha = () => {
      const chars = '0123456789'
      let result = ''
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      captchaText.value = result
    }

    // 刷新验证码
    const refreshCaptcha = () => {
      generateCaptcha()
    }

    // 验证码验证规则
    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (value !== captchaText.value) {
        callback(new Error('验证码不正确'))
      } else {
        callback()
      }
    }

    const rules = {
      name: [
        { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        { min: 2, max: 10, message: '长度在2到10个字符', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      businessId: [
        { required: true, message: '请选择服务类型', trigger: 'change' }
      ],
      text: [
        { required: true, message: '请输入问题描述', trigger: 'blur' },
        { min: 4, message: '至少输入4个字符', trigger: 'blur' }
      ],

    }

    const handleImageChange = (file, fileList) => {
      const fileTwo = new FormData()
      fileTwo.append('file', file.raw)
      serviceApi.addMinio(fileTwo).then(res => {
        console.log(res.data.data.url)
        imgUrl[number.value]=res.data.data.url
        number.value++
        form.imgs = form.imgs+res.data.data.url+','
      })
    }

    const handleImageRemove = (file, fileList) => {
      // Handle image removal if needed
    }

    const save = () => {
      if(form.text===""||form.name===""||form.businessId===""||form.phone===""){
        ElMessage.error('请填写完整信息')
        return
      }
      if(form.imgs && form.imgs.length > 0) {
        form.imgs=form.imgs.slice(0, -1)
      }
      console.log(form.unitName)
      console.log(form.imgs)
      serviceApi.AddTechnical(form).then(res => {
        form = res.data.data
        form.id=1
        serviceApi.sendAdminTechnicalSupport(form).then(res => {
          resetForm()
        })
        console.log(res.data.data)
        ElMessage.success('提交成功')
      })
    }

    const out = () => {
      dialogVisible.value = false
      location.reload();
    }

    const submitForm = async () => {
      try {
        // Process imgs if they exist
        if (typeof form.imgs === 'string' && form.imgs.length > 0) {
          form.imgs = form.imgs.slice(0, -1);
        }

        // Verify the entire form
        const valid = await formRef.value.validate();
        if (!valid) {
          ElMessage.error('请填写完整且正确的信息');
          return;
        }

        const formData = new FormData();

        // Add all fields except captcha
        Object.keys(form).forEach(key => {
          if (key !== 'captcha') {
            if (form[key] !== undefined && form[key] !== null) {
              formData.append(key, form[key]);
            }
          }
        });

        dialogVisible.value = true;
        console.log('提交的数据:', Object.fromEntries(formData));

      } catch (error) {
        console.error('提交出错:', error);
      }
    };

    const resetForm = () => {
      formRef.value.resetFields()
      fileList.value = []
      form.imgs = ''
      number.value = 0
      imgUrl.value = []
      refreshCaptcha()
    }

    // 初始化生成验证码
    generateCaptcha()

    return {
      formRef,
      form,
      rules,
      number,
      imgUrl,
      fileList,
      solutions,
      dialogVisible,
      captchaText,
      out,
      handleImageChange,
      handleImageRemove,
      submitForm,
      resetForm,
      save,
      refreshCaptcha
    }
  },
  created() {
    serviceApi.getBusinessList().then(res =>{
      this.solutions=res.data.data
    })
  }
}
</script>

<style lang="scss" scoped>
.support-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.support-header {
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 150px;
  text-align:left;

  h1 {
    font-size: 30px;
    color: #333;
    margin-bottom: 15px;
    text-align:center;
  }

  .welcome-text {
    font-size: 17px;
    color: #666;
    line-height: 2.5;
    margin-bottom: 10px;
  }

  .contact-info {
    font-size: 18px;
    color: #409EFF;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .address-info,
  .business-hours,
  .phone-info {
    font-size: 16px;
    color: #666;
    line-height: 2.5;
    margin-bottom: 5px;
    text-align:center;
  }

  .form-title {
    font-size: 18px;
    color: #333;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
  }
}

.support-form {
  padding: 0 20px;

  .form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 22px;

    .form-item {
      flex: 1;
      margin-bottom: 0;
    }
  }

  .full-width {
    width: 100%;
    margin-bottom: 22px;
  }

  :deep(.el-form-item__label) {
    font-weight: bold;
  }

  :deep(.el-upload__tip) {
    margin-top: 5px;
    font-size: 12px;
    color: #999;
  }
}

.captcha-container {
  display: flex;
  align-items: center;
}

.captcha-code {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 20px;
  letter-spacing: 5px;
  cursor: pointer;
  user-select: none;
  color: #333;
  border: 1px solid #dcdfe6;
  font-family: Arial, sans-serif;
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 30px;

  .el-button {
    width: 120px;
    margin: 0 15px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .support-container {
    padding: 15px;
  }

  .support-form {
    padding: 0;

    .form-row {
      flex-direction: column;
      gap: 0;

      .form-item {
        margin-bottom: 22px;
      }
    }
  }

  .captcha-container {
    flex-direction: column;
    align-items: flex-start;

    .el-input {
      margin-bottom: 10px;
      margin-right: 0;
      width: 100% !important;
    }

    .captcha-code {
      width: 100px;
    }
  }

  .form-actions .el-button {
    width: 100px;
    margin: 0 10px;
  }
}
</style>